import type { Step } from "react-joyride";

export const optionsFormTourSteps: Step[] = [
  {
    target: "body",
    content:
      "ຟອມສ້າງ/ແກ້ໄຂ Product Option. ຕື່ມຊື່ option 3 ພາສາ (ລາວ, ไทย, EN), slug, ແລະເພີ່ມຄ່າ option values.",
    placement: "center",
    disableBeacon: true,
  },
  {
    target: '[data-tourid="catalog-option-name"]',
    content: "ຊື່ Product Option ໃນ 3 ພາສາ — ພາສາລາວເປັນບັງຄັບ.",
    placement: "bottom",
  },
  {
    target: '[data-tourid="catalog-option-slug"]',
    content:
      "Slug ສຳລັບ URL ແລະການອ້າງອີງ — ຈະຖືກສ້າງອັດຕະໂນມັດຈາກຊື່ພາສາອັງກິດ.",
    placement: "bottom",
  },
  {
    target: '[data-tourid="catalog-option-values"]',
    content:
      "ເພີ່ມຄ່າ option values ເຊັ່ນ Red, Blue, Green ສໍາລັບ Color ຫຼື S, M, L ສໍາລັບ Size.",
    placement: "top",
  },
  {
    target: '[data-tourid="catalog-option-submit"]',
    content: "ກົດ 'ບັນທຶກ' ເພື່ອບັນທຶກ option ຫຼື 'ຍົກເລີກ' ເພື່ອກັບຄືນ.",
    placement: "top",
  },
];
